import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import dataV from '@jiaminghi/data-view';
Vue.use(dataV);

// 按需引入vue-awesome图标
import Icon from 'vue-awesome/components/Icon';
import 'vue-awesome/icons/chart-bar.js';
import 'vue-awesome/icons/chart-area.js';
import 'vue-awesome/icons/chart-pie.js';
import 'vue-awesome/icons/chart-line.js';
import 'vue-awesome/icons/align-left.js';

// 全局注册图标
Vue.component('icon', Icon);

// 适配flex
import './common/flexible.js';

// 引入全局css
import './assets/scss/style.scss';
// element ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

//引入echart
import * as echarts from 'echarts'
// import echarts from 'echarts'
import 'echarts-wordcloud';
import china from '../src/map/json/china.json'
import BaiduMap from 'vue-baidu-map'
echarts.registerMap('china', china)
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false;

import axios from 'axios'
// axios.defaults.baseURL = '/api/'
Vue.prototype.$axios = axios
router.beforeEach((to, from, next)=>{
  if(to.meta.title){
    document.title = to.meta.title
  }
  next()
})
Vue.use(ElementUI);
Vue.use(BaiduMap, {
  ak: '4Oufl5cReYsVMOqaezibCoCUcXqKTTh1'
})
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
